<template>
  <div>
    <header-unauthenticated></header-unauthenticated>
    <div class="container">
      <div class="login login--header-padding">
        <img src="@/assets/superliga/logo-3x.png" alt="" class="login__logo" v-if="$config.MODE == 'SUPERLIGA'">
        <img src="@/assets/logo.svg" alt="" class="login__logo" v-else>
        <div class="form-group">
          <input 
          type="email"
          v-model.trim="$v.recoveryEmail.$model"
          :class="{'has-error': $v.recoveryEmail.$error && $v.recoveryEmail.$invalid, 'with-value': $v.recoveryEmail.$model != ''}"
          :id="$t('recoveryPassword.form.email')" class="form-control" required>
          <label class="form-control-placeholder" :for="$t('recoveryPassword.form.email')">{{$t('recoveryPassword.form.email')}}</label>
        </div>
        
        <button class="button button--white" @click.prevent="recoveryPassword()" :disabled="$v.recoveryEmail.$invalid || submitted">
          <template v-if="!submitted">
            {{$t('recoveryPassword.recoveryPassword')}}
          </template>
          <template v-else>
            {{$t('recoveryPassword.loadingRecoveryPassword')}} <div class="loading-points"><span>.</span><span>.</span><span>.</span></div>
          </template>
          
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import HeaderUnauthenticated from '@/components/Header/Unauthenticated.vue'

export default {
  components: {
    HeaderUnauthenticated
  },
  data() {
    return {
      recoveryEmail: "",
      submitted: false
    }
  },
  methods: {
    async recoveryPassword() {
      const self = this
      self.$v.$touch()
      if (!self.$v.$invalid) {
        this.submitted = true
        const request = await this.$store.dispatch('beginPasswordRecovery', {
          email: self.recoveryEmail
        })
        if (request == undefined) this.submitted = false
        if (request.status == 200) this.$router.push(`/recoverPassword/code/${self.recoveryEmail}`)
      }
    }
  },
  validations: {
    recoveryEmail: {
      required,
      email
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';
</style>